"use client";
import styles from "./page.pc.module.scss";
import React, { useState, useEffect, useRef } from "react";
let timer = null;

const ClosedJob = ({ data, lang }) => {
  const [time, setTime] = useState(3);
  const timerRef = useRef(3);
  useEffect(() => {
    timer = setInterval(() => {
      timerRef.current = timerRef.current - 1;
      if (timerRef.current < 0) {
        clearInterval(timer);
        window.location.href = data?.is_remote
          ? `/${lang}/remote-jobs-hiring/jobs`
          : `/${lang}/jobs-hiring/job-search`;
        return;
      }
      setTime(timerRef.current);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={styles.closedJob}>
      <div className={styles.content}>
        <svg
          width='180'
          height='180'
          viewBox='0 0 180 180'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M40.5845 144.824H131.415V47.0654C131.415 40.438 126.042 35.0654 119.415 35.0654H32.9438V35.0734C37.1953 35.2613 40.5845 38.7676 40.5845 43.0654V144.824Z'
            fill='#F7FAFF'
          />
          <rect x='54.6963' y='75.9756' width='61.9268' height='3' fill='#D8E9FF' />
          <rect x='54.6963' y='85.9756' width='61.9268' height='3' fill='#D8E9FF' />
          <rect x='54.6963' y='95.9756' width='61.9268' height='3' fill='#D8E9FF' />
          <rect x='54.6963' y='105.976' width='61.9268' height='3' fill='#D8E9FF' />
          <rect x='54.6963' y='115.976' width='61.9268' height='3' fill='#D8E9FF' />
          <rect x='54.6963' y='125.976' width='61.9268' height='3' fill='#D8E9FF' />
          <circle cx='64.0078' cy='60.2256' r='9.31152' fill='#FFCC00' />
          <path
            d='M67.3066 100.098C67.3066 100.098 56.5663 123.556 44.6831 122.313C32.7999 121.069 34.8061 110.215 39.8912 106.947C44.9764 103.679 49.2481 106.402 49.2674 111.451C49.2868 116.5 46.8541 126.66 33.2752 128.402'
            stroke='#121212'
            strokeWidth='1.2'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M133.123 75.7137L130.341 64.6585C130.006 63.3252 128.807 62.3906 127.432 62.3906H111.517C110.142 62.3906 108.943 63.3252 108.608 64.6585L105.826 75.7137'
            stroke='#121212'
            strokeWidth='1.2'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <rect x='92.4722' y='74.4673' width='54.0053' height='38.6311' rx='2' fill='#2378E5' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M107.248 73.7056V71.2056H102.248V73.7056V102.659V105.159H107.248V102.659V73.7056ZM136.701 73.7056V71.2056H131.701V73.7056V102.659V105.159H136.701V102.659V73.7056Z'
            fill='white'
          />
          <path
            d='M90 72.7354C90 71.0785 91.3431 69.7354 93 69.7354H145.949C147.606 69.7354 148.949 71.0785 148.949 72.7354V84.442C148.949 85.817 148.014 87.0161 146.681 87.3514L120.206 94.0086C119.726 94.1294 119.223 94.1294 118.743 94.0086L92.2684 87.3514C90.9348 87.0161 90 85.817 90 84.442V72.7354Z'
            fill='#2378E5'
          />
          <path
            d='M92.5749 87.3911L119.475 94.4581L146.374 87.3911'
            stroke='#121212'
            strokeWidth='1.2'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
        </svg>
        <h1>{data?.title}</h1>
        <p>
          {data?.sub_title} <span>{time}s</span>
        </p>
      </div>
    </div>
  );
};

export default ClosedJob;
